// HOOKS
import { useMutation } from "@apollo/client";
import { useState, useCallback, useEffect } from "react";
// GRAPHQL
import { UPDATE_ASSET } from "../../graphql/mutations/assets/assets.mutations";

const useUpdateAsset = () => {
  const [timedUpdate, setTimedUpdate] = useState(null);
  const [updateAssetMutation, { loading, error, data }] =
    useMutation(UPDATE_ASSET);

  // Using useCallback to ensure function stability if used as a dependency elsewhere
  const updateAsset = useCallback(
    async (asset) => {
      if (timedUpdate) clearTimeout(timedUpdate);

      const timeout = setTimeout(() => {
        // Remove __typename from input
        const filteredAsset = Object.entries(asset)
          .filter(([key]) => key !== "__typename")
          .reduce((obj, [key, value]) => {
            obj[key] = value;
            return obj;
          }, {});

        updateAssetMutation({
          variables: { asset: { ...filteredAsset } },
        }).catch((apolloError) => {
          // If needed, handle Apollo Client errors specifically here
          console.error(`Apollo error updating asset: ${apolloError.message}`);
          alert(`Apollo error updating asset: ${apolloError.message}`);
        });
      }, 800);

      setTimedUpdate(timeout);
    },
    [updateAssetMutation, timedUpdate]
  );

  // Ensure to clear the timeout on component unmount to prevent memory leaks
  useEffect(() => {
    return () => {
      if (timedUpdate) clearTimeout(timedUpdate);
    };
  }, [timedUpdate]);

  return { updateAsset, loading, error, data };
};

export default useUpdateAsset;
